import { Link } from "react-router-dom";
import { PublicLayout } from "@/components/site/PublicLayout";
import { Home } from "lucide-react";

export default function NotFound() {
    return (
        <PublicLayout>
            <section className="container-x grid min-h-[60vh] place-items-center py-20 text-center">
                <div>
                    <div className="overline">404</div>
                    <h1 className="mt-3 font-serif text-6xl text-slate-900">Page not found</h1>
                    <p className="mt-4 text-slate-600">The page you're looking for has moved or doesn't exist.</p>
                    <Link to="/" className="btn-primary mt-6"><Home size={16} /> Back to home</Link>
                </div>
            </section>
        </PublicLayout>
    );
}
